import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { withLatestFrom, map, filter } from 'rxjs/operators';

import { NavigationEvents, isNavigationAction } from 'src/components/NavigationListener/types';

import { CustomerInfo, isCustomerInfo } from './types';

/**
 * Epic to handle logged-in users navigating to checkout for Meta analytics
 */
function metaLoggedInUsersEpic(action$: Observable<any>, state$: Observable<any>): Observable<CustomerInfo> {
    return action$.pipe(
        ofType(NavigationEvents.NAVIGATION_COMPLETE),

        // Only trigger when the user navigates to the checkout page
        filter((action) => isNavigationAction(action) && action.payload.pathname.startsWith('/checkout')),

        withLatestFrom(state$),

        map(([, state]: [unknown, any]) => {
            const user = state.user ?? {};

            const email = user.data?.email;
            const firstName = user.data?.firstname ?? undefined;
            const lastName = user.data?.lastname ?? undefined;

            if (email && firstName && lastName) {
                const customerInfo: CustomerInfo = {
                    email,
                    firstName,
                    isGuest: false,
                    lastName,
                };

                return customerInfo;
            }

            return null;
        }),

        // Filter out null values
        filter(isCustomerInfo),
    );
}

export default metaLoggedInUsersEpic;
